var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZimbabwe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72.47 66.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m55.62 65-.8-.55-1.11-.36-1.4-.16-1.83.07-2.24.31-2.41-.37-2.57-1-2.14-.37-2.55.43h-.11l-.46-.37-.7-.75-1.16-.13-.32-.17-.26-.28-.17-.36-.06-.39.19-1.23-.11-.14-.29-.18-.64-.14-1.48-.53-2-.54-3.1-.59-1.21-.2-.29-.18-.35-.45-.6-1.37-.56-.93-1.35-1.43-.21-.44.07-1.14.1-.92.14-.77-.07-.73v-1.51l-.18-.26-.49-.18-1.39-.09h-1.68l-.05-.92-.17-1.42-.31-.81-.39-.42-.77-.45-1.53-.58-2.13-.92-1.82-1.36-2.08-1.69-.65-.29-.77-1.58L8 33.47l.07-.9-.17-.45-1.15-1.32-.25-.69-.2-.7-1.81-1.94-.62-.85-.47-1.08-.47-.87-.39-.35-.54-.59-.35-.67-.17-.51.14-.67.17-.46 1.72.48h.94l.74-.24.91.32 1.09.87 1.18.17 1.28-.54 1.73.17 2.18.87 1.81.17 2.17-.69 1.92-2.14 1.8-2L23 16.48l1.07-1.88 1.56-1.52 2.07-1.17 2.11-1 3.22-1.21h0l.64-1 .22-1.09v-1.5l.16-1 .34-.45.61-.33.69-.45 2.12-1.15L39.55 2l2.17-.49h6V3l.1 1.64.26.16h1.72l2.75.12 2.61.08 1.7 1.19.57.25 1.76.32 2.25 2 2.71.19 1.85.61 1.64.68.94.81.61.19.83.06.4.07-.09.59-.55 1 .07 1.43.76 2 .11 1.73-.24 3.05v3l.08 1.06.12.7.17.38v.44L70.39 28 70 29.26v.52l-.14.37-.27.33-1.19.61-.2.38v.68l.15.57.44.21.54.32.21.43v.45l-.14.87-.48 1.38.48 1.62.53 1 .73 1.2.31.74v.53l-.11.52-1.1 2.19-.76 1.35L68 47l-1.27.92-.33.45-.13.5v1.1l-.06 1.15-1.09 1.77.68 1.53-.16.14-.37.22-1.57 1.72-1.59 1.75L61 59.51 59.64 61l-1.48 1.63L56.89 64z",
    "data-name": "Layer 93"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZimbabwe);
export default __webpack_public_path__ + "static/media/zimbabwe.5ae830f504b011651cfa186e5251b2e6.svg";
export { ForwardRef as ReactComponent };